import { useMemo } from 'react';

// Tab counts plus tab and search filtering for the marketing list pages.
// `statusOf` and `searchFields` should be module-level functions so the memos stay stable.
export function useListFilter(items, { statusOf, searchFields, tab, q }) {
  const counts = useMemo(() => items.reduce((acc, it) => {
    acc.all += 1;
    const s = statusOf(it);
    acc[s] = (acc[s] || 0) + 1;
    return acc;
  }, { all: 0 }), [items, statusOf]);

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return items.filter(it => (tab === 'all' || statusOf(it) === tab)
      && (!needle || searchFields(it).filter(Boolean).join(' ').toLowerCase().includes(needle)));
  }, [items, statusOf, searchFields, tab, q]);

  return { counts, filtered };
}
